//import {CurrentUser} from '../models/CurrentUser';
import { Injectable, EventEmitter } from '@angular/core';
import { UserInfo } from '../../model/user';
import { StartFunctionResponseModel } from '../../model/startFunctionResponseModel';
import { UserData } from '../utils/CurrentPageWatcher';

@Injectable()  
export class StorageService {
 
    userInfo:EventEmitter<UserInfo>=new EventEmitter<UserInfo>();
    notifySessionData:EventEmitter<SessionData>=new EventEmitter<SessionData>();

    constructor() { }

    public setSessionData(sessionData:SessionData){
       localStorage.setItem('sessionData',JSON.stringify(sessionData));
       this.getNotifySessionData().emit(sessionData);
    }

    public  getSessionData():SessionData{        
         return JSON.parse(localStorage.getItem('sessionData')); 
    }

    public setStartFunctionData(startFunctionData:StartFunctionResponseModel){
        localStorage.setItem('startFunction',JSON.stringify(startFunctionData));
     }
 
     public getStartFunctionData():StartFunctionResponseModel{        
          return JSON.parse(localStorage.getItem('startFunction')); 
     }

    public clear():void{
        localStorage.clear();
    }
    public clearStartFunctionData():void{
        localStorage.removeItem('startFunction');
    }

    public getNotifySessionData(){
        return this.notifySessionData;
    }
    
}

export class SessionData{

public userSessionId :number;
public token:string;
public userData? : UserData;
}


// WEBPACK FOOTER //
// ./src/app/shared/security/StorageService.ts